export default __webpack_public_path__ + "static/media/next-button.b3ff3d5b.svg";